import { toast } from "sonner";
import { api, API } from "./api";

export const BASE = process.env.REACT_APP_BACKEND_URL;

export function openPdfWindow(path, title) {
  const win = window.open("", "_blank");
  fetch(`${API}${path}`, { headers: { Authorization: `Bearer ${localStorage.getItem("norea_token")}` } })
    .then(async (r) => { if (!r.ok) throw new Error((await r.json().catch(() => ({}))).detail); return r.blob(); })
    .then((b) => {
      const url = URL.createObjectURL(b);
      if (win) { win.document.title = title; win.document.body.style.margin = "0"; win.document.body.innerHTML = `<iframe src="${url}" title="${title}" style="border:0;position:fixed;inset:0;width:100vw;height:100vh"></iframe>`; }
    })
    .catch((e) => { win?.close(); toast.error(e.message || "Génération impossible"); });
}

export const previewDoc = (dossierId, doc) => openPdfWindow(`/dossiers/${dossierId}/send-docs/${doc.id}/pdf`, doc.name);

export function draftToForm(d) {
  return { role: d.role, docs: d.docs || [], templates: d.templates || [], template_id: d.template_id, missing: d.missing || [], label: "",
    attachments: (d.attachments || []).map((a) => ({ ...a, on: a.files > 0 })), recipients: d.recipients, signable: d.signable, signer: d.signer, yousign: { configured: d.yousign_configured, env: d.yousign_env, mode: d.signature_mode }, channels: { email: !!d.email.to || !d.whatsapp.to, whatsapp: !d.email.to && !!d.whatsapp.to },
    email: { ...d.email, cc: "" }, whatsapp: { ...d.whatsapp } };
}

export const loadDraft = (dossierId, docIds, role, templateId) =>
  api.get(`/dossiers/${dossierId}/send-draft`, { params: { docs: docIds.join(","), role, template_id: templateId } }).then((r) => draftToForm(r.data));

export const loadMessageDraft = (dossierId, templateId, role) =>
  api.get(`/dossiers/${dossierId}/message-draft`, { params: { template_id: templateId, role } }).then((r) => {
    const f = draftToForm(r.data);
    return { ...f, label: r.data.templates.find((t) => t.id === r.data.template_id)?.name || "" };
  });

export const MISSING_MARK = "[à compléter";
const stillMissing = (form) => [form.channels.email && `${form.email.subject}\n${form.email.body}`, form.channels.whatsapp && form.whatsapp.text].filter(Boolean).join("\n").includes(MISSING_MARK);

export async function sendForm(dossierId, form, win) {
  const channels = Object.entries(form.channels).filter(([, v]) => v).map(([k]) => k);
  if (stillMissing(form) && !window.confirm("Certaines variables sont encore « à compléter » dans le message. Envoyer quand même ?")) throw Object.assign(new Error("cancel"), { response: { data: { detail: "Envoi annulé : complétez les variables vides" } } });
  const body = { docs: form.docs.map((d) => d.id), pieces: (form.attachments || []).filter((a) => a.on && a.kind === "piece").map((a) => a.id), template_id: form.template_id, label: form.label || "",
    role: form.role, channels, base_url: BASE,
    email: form.channels.email ? { ...form.email, cc: form.email.cc.split(",").map((s) => s.trim()).filter(Boolean) } : undefined,
    whatsapp: form.channels.whatsapp ? form.whatsapp : undefined };
  const r = await api.post(`/dossiers/${dossierId}/send`, body);
  if (r.data.whatsapp_url && win) win.location.href = r.data.whatsapp_url;
  else win?.close();
  return r.data;
}

export const formReady = (f) => !!f && (f.channels.email || f.channels.whatsapp)
  && (!f.channels.email || !!f.email.to.trim()) && (!f.channels.whatsapp || !!f.whatsapp.to.trim());
